import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

serviceWorkerRegistration.register();

window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();

  window.deferredPrompt = e;

  const installBtn = document.getElementById('install-btn');
  if (installBtn) installBtn.style.display = 'block';
});

reportWebVitals();
